import { Option } from "./Option";
import { MultiValue } from "./MultiValue";
import { SingleValue } from "./SingleValue";
import { CombinedSelectComponents, CombinedStylesConfig } from "./types";

export const SELECT_CUSTOM_COMPONENTS: CombinedSelectComponents = {
  MultiValue,
  Option,
  SingleValue,
};

const PURPLE_BASE = "#4D2481";
const GRAY_BASE = "rgba(0, 0, 0, 0.20)";

const MENU_MAX_HEIGHT = "300px";
const INPUT_HEIGHT = "54px";
const BORDER_THICKNESS = "1px";
const SCROLLBAR_SIZE = "0px";

export const SELECT_CUSTOM_STYLES: CombinedStylesConfig = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    minHeight: INPUT_HEIGHT,
    border: `${BORDER_THICKNESS} solid ${GRAY_BASE}`,
    cursor: "pointer",
    borderRadius: state.menuIsOpen
      ? "20px 20px 0px 0px"
      : "20px 20px 20px 20px",
    boxShadow: "none",
    "&:hover": {}, // empty obj - no styles
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    boxShadow: "none",
    border: `${BORDER_THICKNESS} solid ${GRAY_BASE}`,
    margin: "0",
    maxHeight: MENU_MAX_HEIGHT,
    borderRadius: "0px 0px 20px 20px",
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "20px",
    color: PURPLE_BASE,
    "::-webkit-scrollbar": {
      width: SCROLLBAR_SIZE,
      height: SCROLLBAR_SIZE,
    },
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: "0px 12px",
    gap: "5px",
  }),
  indicatorsContainer: () => ({ display: "none" }),
};
